// extracted by mini-css-extract-plugin
export var departmentListStyle = "search_jobs_result_list_wrapper-module--departmentListStyle--ELsNt";